import React, { useState } from "react";

function Slider({ onChange }) {
  const [value, setValue] = useState(0);

  return (
    <>
      <p className="text-2xl font-bold">£{value}</p>
      <div className="flex items-center">
        <p className="mr-3 mb-0">£0</p>
        <input
          type="range"
          min="0"
          max="10000"
          value={value}
          onChange={(e) => {
            const value = Number(e.target.value);
            setValue(value);
            onChange(value);
          }}
          className="appearance-none w-full h-2 bg-lightGray border border-mediumGray rounded outline-none slider-thumb"
        />
        <p className="ml-3 mb-0">£10,000</p>
      </div>
    </>
  );
}

export default Slider;
